"use client";

import type { ReactNode } from "react";
import { Button } from "../components/Buttons";

export const APP_ROUTER_ERROR_COPY = {
  title: "Something went wrong",
  description: "We have been notified and are working on it.",
  retryLabel: "Try again",
} as const;

type AppRouterErrorFallbackProps = {
  reset: () => void;
  minHeightClass?: string;
};

export function AppRouterErrorFallback({
  reset,
  minHeightClass = "min-h-[50vh]",
}: AppRouterErrorFallbackProps) {
  return (
    <div
      role="alert"
      aria-labelledby="app-router-error-heading"
      className={`flex ${minHeightClass} flex-col items-center justify-center gap-4 p-8`}
    >
      <h1 id="app-router-error-heading" className="text-xl font-semibold">
        {APP_ROUTER_ERROR_COPY.title}
      </h1>
      <p className="text-center text-sm opacity-70">
        {APP_ROUTER_ERROR_COPY.description}
      </p>
      <Button type="button" onClick={reset}>
        {APP_ROUTER_ERROR_COPY.retryLabel}
      </Button>
    </div>
  );
}

type AppRouterGlobalErrorShellProps = {
  bodyClassName: string;
  children: ReactNode;
};

export function AppRouterGlobalErrorShell({
  bodyClassName,
  children,
}: AppRouterGlobalErrorShellProps) {
  return (
    <html lang="en">
      <head>
        <title>{APP_ROUTER_ERROR_COPY.title}</title>
      </head>
      <body className={bodyClassName}>{children}</body>
    </html>
  );
}
